/*
    • within ProductCardLayout, this context provider shares the height of the two top-row elements for this layout
    • the second of these rows then uses the height difference to adjust the vertical position of
      the "Details" component upwards to vertically tighten the display
*/

import React, { useContext } from 'react';


// defined here instead of within ProductCardLayout to avoid circular references
const ProductCardLayoutContext = React.createContext();

function useProductCardLayout() {
    return useContext(ProductCardLayoutContext);
}


export { ProductCardLayoutContext };
export default useProductCardLayout;
